import { useTranslation } from 'react-i18next';
import { supabase } from '../../../lib/supabase';
import { useEffect, useState } from 'react';

export default function Pricing() {
  const { t } = useTranslation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setIsLoggedIn(!!session);
    });
  }, []);

  const handleUpgrade = () => {
    if (isLoggedIn) {
      window.REACT_APP_NAVIGATE('/dashboard?upgrade=true');
    } else {
      window.REACT_APP_NAVIGATE('/login?redirect=dashboard&upgrade=true');
    }
  };

  return (
    <section id="pricing" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('pricing.title')}
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            {t('pricing.subtitle')}
          </p>
        </div>

        <div className="max-w-md mx-auto">
          <div className="relative bg-white rounded-2xl p-8 border-2 border-teal-500 shadow-2xl shadow-teal-500/20">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2">
              <div className="bg-gradient-to-r from-teal-500 to-teal-600 text-white px-4 py-1 rounded-full text-xs font-semibold whitespace-nowrap">
                Best Value
              </div>
            </div>

            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">{t('plan.pro.name')}</h3>
              <p className="text-sm text-gray-600 mb-6">{t('plan.pro.desc')}</p>
              <div className="flex items-end justify-center mb-2">
                <span className="text-5xl font-bold text-gray-900">{t('plan.pro.price')}</span>
              </div>
              <p className="text-sm text-gray-600">{t('plan.pro.period')}</p>
            </div>

            <ul className="space-y-4 mb-8">
              <li className="flex items-start">
                <i className="ri-check-line text-teal-600 text-xl mr-3 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">{t('plan.pro.feature1')}</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-teal-600 text-xl mr-3 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">{t('plan.pro.feature2')}</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-teal-600 text-xl mr-3 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">{t('plan.pro.feature3')}</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-teal-600 text-xl mr-3 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">{t('plan.pro.feature4')}</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-teal-600 text-xl mr-3 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">{t('plan.pro.feature5')}</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-teal-600 text-xl mr-3 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">{t('plan.pro.feature6')}</span>
              </li>
            </ul>

            <button
              onClick={handleUpgrade}
              className="w-full py-3 rounded-xl font-semibold transition-all whitespace-nowrap cursor-pointer bg-gradient-to-r from-teal-500 to-teal-600 text-white hover:shadow-lg hover:shadow-teal-500/30"
            >
              {t('plan.pro.cta')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}